<i18n lang='yml' src='../i18n/SubmitSurvey.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else>
    <div v-if="requestableRoles.length==0">
      <p>
        {{ $t('no_requestable_roles') }}
      </p>
    </div>
    <div v-else-if="noSurveyQuestionsReceived">
      <div v-if="codeRequired">
        <div class="form-group row">
          <div class="col-md-4">
            <legend><strong class="text-danger">* <span class="sr-only">{{ $t('required') }}</span></strong>{{ $t('membership_code') }}</legend>
            <input class="form-control" type="text" name="survey_responses[container_membership_code]" v-model="container_membership_code"/>
            <a v-on:click="showNoCodeText" href="#">
              {{$t('no_code')}}
            </a>
          </div>
        </div>
        <div v-if="noCode">
          <div class="form-group row">
            <div class="col-md-4">
              <div class="col-md-12 alert alert-warning" v-html="no_code_help_text"/>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div v-if="Object.keys(errors).length > 0">
            <strong> {{ $t('errors') }}</strong>
            <ul>
              <li v-for="error in errors" class="text-danger"> {{ error.message }} </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="border-bottom light clearfix">
              <div>
                <button type="submit" class="btn btn-sm btn-success">
                  <font-awesome-icon :icon="['fas', 'save']"/>
                  {{ $t('submit_answers') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!codeRequired" class="row">
        <div class="col-sm-12">
          <div class="border-bottom light clearfix">
            <div>
              <button type="submit" class="btn btn-sm btn-success">
                <font-awesome-icon :icon="['fas', 'save']"/>
                {{ $t('submit_answers') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" name="survey_responses[network_role_id]" :value="defaultRole.id"/>
      <input type="hidden" name="survey_responses[responses][]" value="" />
    </div>
    <div v-else>
      <div v-if="codeRequired" class="form-group row">
        <div class="col-md-4">
          <legend><strong class="text-danger">* <span class="sr-only">{{ $t('required') }}</span></strong>{{ $t('membership_code') }}</legend>
          <input class="form-control" type="text" name="survey_responses[container_membership_code]" v-model="container_membership_code"/>
          <a v-on:click="showNoCodeText" href="#">
            {{$t('no_code')}}
          </a>
        </div>
      </div>
      <div v-if="noCode">
        <div class="form-group row">
          <div class="col-md-4">
            <div class="col-md-12 alert alert-warning" v-html="no_code_help_text"/>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4">
          <p>
            {{ $t('select_role') }}
          </p>
          <select v-model="selectedRole" name="survey_responses[network_role_id]" class="form-control ">
            <option v-for="role in requestableRoles" :value="role.id"> {{ role.name_en }} </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <p v-if="selectedRole">
            {{ $t('answer_registration_questions') }}
          </p>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4" v-if="Object.keys(errors).length > 0">
          <strong> {{ $t('errors') }}</strong>
          <ul>
            <li v-for="error in errors" class="text-danger"> {{ error.message }} </li>
          </ul>
        </div>
      </div>
      <div class="border-bottom">
        <div v-for="question in visibleQuestionList" v-bind:key="question.id">
          <input type="hidden" :name="'survey_responses[responses][' + question.id + '][survey_question_id]'" :value="question.survey_question_id"/>
          <input type="hidden" :name="'survey_responses[responses][' + question.id + '][response_text]'" value="" />

          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-6">
              <div class="form-group">
                <!-- <div class="label-p"><strong v-if="question.required" style="color: red">* <span class="sr-only">Required</span></strong>{{ question.title }}</div> -->
                <template v-if="questionIsSelectOne(question)">
                  <fieldset>
                    <legend><strong v-if="question.required" class="text-danger">* <span class="sr-only">{{ $t('required') }}</span></strong>{{ question.title }}</legend>
                    <div class="radio" v-for="answer in question.answers">
                      <label>
                        <input type="radio" :name="'survey_responses[responses][' + question.id + '][survey_answer_id]'" v-model="responses[question.id].survey_answer_id" :value="answer.id">
                        {{ answer.answer_text }}
                      </label>
                    </div>
                  </fieldset>
                </template>
                <template v-else-if="questionIsSelectMultiple(question)">
                  <label :for="'survey_responses[responses][' + question.id + '][survey_answer_id]'"><strong v-if="question.required" style="color: red">* <span class="sr-only">{{ $t('required') }}</span></strong>{{ question.title }}</label>
                  <select :id="'survey_responses[responses][' + question.id + '][survey_answer_id]'" :name="'survey_responses[responses][' + question.id + '][survey_answer_id]'" class="form-control" v-model="responses[question.id].survey_answer_id">
                    <option v-for="answer in question.answers" :value="answer.id">
                      {{ answer.answer_text }}
                    </option>
                  </select>
                </template>
                <template v-else-if="questionIsTextEntry(question)">
                  <label :for="'survey_responses[responses][' + question.id + '][response_text]'"><strong v-if="question.required" style="color: red">* <span class="sr-only">{{ $t('required') }}</span></strong>{{ question.title }}
                    <input type="text" :id="'survey_responses[responses][' + question.id + '][response_text]'" :name="'survey_responses[responses][' + question.id + '][response_text]'" v-model="responses[question.id].response_text" class="form-control" />
                  </label>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="selectedRole">
        <div class="col-sm-12">
          <div class="border-bottom light clearfix">
            <div>
              <button type="submit" class="btn btn-sm btn-success">
                <font-awesome-icon :icon="['fas', 'save']" />
                {{ $t('submit_answers') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { REGEXP } from "../../shared/util";
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts'

  export default {
    props: {
      api_path: { type: String },
      load_path: { type: String },
      form_id: { type: String },
      roles: { type: String },
      valid_codes: { type: String },
      code_required: { type: String },
      no_code_help_text: {type: String}
    },

    data() {
      return {
        loading: true,
        questions: {},
        responses: {},
        errors: {},
        codeRequired: false,
        container_membership_code: '',
        requestableRoles: JSON.parse(this.roles),
        selectedRole: null,
        defaultRole: null,
        noSurveyQuestionsReceived: false,
        noCode: false
      };
    },

    methods: {
      questionIsSelectOne: question => question.type === "select_one",
      questionIsSelectMultiple: question => question.type === "select_multiple",
      questionIsTextEntry: question => question.type === "text_entry",

      showNoCodeText(event) {
        event.preventDefault()
        if(this.noCode) {
          this.noCode = false;
        }
        else {
          this.noCode = true;
        }
      },

      fetchQuestions() {
        const _vm = this;
        $.ajax({
          type: "GET",
          url: this.load_path,
          contentType: "application/json",
          success: response => {
            _vm.initializeSelectedRole();
            _vm.loadQuestionData(response);
            _vm.fixSelect2Dropdowns();
            _vm.noSurveyQuestionsReceived = response.length === 0;
            _vm.loading = false;

            _vm.$nextTick(() => {
              if (_vm.noSurveyQuestionsReceived && !this.codeRequired) {
                $(`#${this.form_id}`).submit();
              }
            })
          },
          error: response => {
            alert("Error loading onboarding questions. :(");
            console.log(response);
          }
        })
      },

      throwError() {
        alert("Error loading onboarding questions. :(");
        console.log(response);
      },

      initializeSelectedRole() {
        this.defaultRole = this.requestableRoles.filter((item) => item.default === true)[0];
        this.selectedRole = this.defaultRole.id;
      },

      loadQuestionData(data) {
        console.log(data)
        data.forEach(item => {
          if (!this.questions.hasOwnProperty(item.network_role_id)) {
            this.questions[item.network_role_id] = [];
          }

          this.questions[item.network_role_id].push({
            id: item.id,
            position: item.position,
            survey_question_id: item.survey_question.id,
            title: item.survey_question.question_text,
            type: item.survey_question.question_type,
            required: item.survey_question.required,
            validation_type: item.survey_question.validation_type,
            answers: item.survey_question.valid_survey_answers,
          });

          this.responses[item.id] = {
            id: null,
            survey_question_id: item.survey_question.id,
            survey_answer_id: null,
            response_text: null,
          };

          this.questions[item.network_role_id].sort((a,b) => a.position - b.position)
        });
      },

      validateContainerMembershipCode() {
        if(this.container_membership_code == "") {
          this.errors[0] = {
            message: this.$t('validations.required', {question_title: 'Container Membership Code'}),
          };
        }
        else if (!JSON.parse(this.valid_codes).includes(this.container_membership_code)) {
          this.errors[0] =  {
            message: this.$t('validations.invalid.code'),
          };
        }
      },

      validateResponseData() {
        this.errors = {};

        this.visibleQuestionList.forEach(question => {
          let response = this.responses[question.id];
          let isResponseTextEmpty = (response) => response.response_text === null || response.response_text.trim() === "";

          if (question.required) {
            if (this.questionIsTextEntry(question)) {
              if (isResponseTextEmpty(response)) {
                this.errors[question.id] = {
                  message: this.$t('validations.required', {question_title: question.title}),
                };
                return; // This error message is more important than anything else we could possibly whine about.
              }
            } else if (!response.survey_answer_id){
              this.errors[question.id] = {
                message: this.$t('validations.required', {question_title: question.title}),
              };
              return;

            }
          }

          if (question.validation_type && this.questionIsTextEntry(question)) {
            if (question.validation_type === 'email' && !isResponseTextEmpty(response)) {
              if (!REGEXP.email.test(response.response_text)) {
                this.errors[question.id] = {
                  message: this.$t('validations.invalid.email')
                };
              }
            } else if (question.validation_type === 'date' && !isResponseTextEmpty(response)) {
              if (!REGEXP.date.test(response.response_text)) {
                this.errors[question.id] = {
                  message: this.$t('validations.invalid.date')
                };
              }
            } else if (question.validation_type === 'phone' && !isResponseTextEmpty(response)) {
              if (!REGEXP.phone.test(response.response_text)) {
                this.errors[question.id] = {
                  message: this.$t('validations.invalid.phone')
                };
              }
            }
          }
        });
      },

      submitSurvey(event) {
        this.validateResponseData();
        if(this.codeRequired) {
          this.validateContainerMembershipCode();
        }
        if (Object.keys(this.errors).length > 0) {
          event.preventDefault();
          event.stopPropagation();
        }
      },

      fixSelect2Dropdowns() {
        const self = this;
        this.$nextTick(() => {
          var options = {
            theme: "bootstrap",
            multiple: true
          };

          Object.keys(this.$refs).forEach(k => {
            $(self.$refs[k]).select2(options);
          });
        });
      },
    },

    mounted() {
      $(`#${this.form_id}`).on("submit", this.submitSurvey);
      this.fetchQuestions();
      this.codeRequired = this.code_required == 'true' ? true: false
    },

    computed: {
      visibleQuestionList: function() {
        if (this.selectedRole && this.questions.hasOwnProperty(this.selectedRole)) {
            return this.questions[this.selectedRole];
        } else {
          return [];
        }
      }
    }
  };
</script>
